import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import { s3Static } from '../../utils/constants'

export const BlogItem = (props) => {
    const post = props.post
    const variant = props.variant || "default"
  return (
    <>
        {(post.categories?.nodes[0]?.slug === "hvac-services") &&
            <Link href={"/sg/aircon-servicing-singapore/"+ post.slug} prefetch={false} className={`${variant === "dark" ? "text-gray-300" : "text-orange-600"}`}>
                <h3 className='md:h-20 font-bold text-center text-sm md:text-base line-clamp-3 md:line-clamp-none'>{post.title}</h3>
            </Link>
        }
        {(post.categories?.nodes[0]?.slug === "health-fitness") &&
            <Link href={"/sg/blogs/health-fitness/"+ post.slug} prefetch={false} className={`${variant === "dark" ? "text-gray-300" : "text-orange-600"}`}>
                <h3 className='md:h-20 font-bold text-center text-sm md:text-base line-clamp-3 md:line-clamp-none'>{post.title}</h3>
            </Link>
        }
        {(post.categories?.nodes[0]?.slug === "house-keeping") &&
            <Link href={"/sg/part-time-cleaner-singapore/"+ post.slug} prefetch={false} className={`${variant === "dark" ? "text-gray-300" : "text-orange-600"}`}>
                <h3 className='md:h-20 font-bold text-center text-sm md:text-base line-clamp-3 md:line-clamp-none'>{post.title}</h3>
            </Link>
        }
        {(post.categories?.nodes[0]?.slug === "repair-renovation") &&
            <Link href={"/sg/handyman-singapore-services/"+ post.slug} prefetch={false} className={`${variant === "dark" ? "text-gray-300" : "text-orange-600"}`}>
                <h3 className='md:h-20 font-bold text-center text-sm md:text-base line-clamp-3 md:line-clamp-none'>{post.title}</h3>
            </Link>
        }
        {(post.categories?.nodes[0]?.slug === "finance-insurance-investment") &&
            <Link href={"/sg/financial-adviser-singapore/"+ post.slug} prefetch={false} className={`${variant === "dark" ? "text-gray-300" : "text-orange-600"}`}>
                <h3 className='md:h-20 font-bold text-center text-sm md:text-base line-clamp-3 md:line-clamp-none'>{post.title}</h3>
            </Link>
        }
        {(post.categories?.nodes[0]?.slug === "housing") &&
            <Link href={"/sg/property-agent/"+ post.slug} prefetch={false} className={`${variant === "dark" ? "text-gray-300" : "text-orange-600"}`}>
                <h3 className='md:h-20 font-bold text-center text-sm md:text-base line-clamp-3 md:line-clamp-none'>{post.title}</h3>
            </Link>
        }
        {(post.categories?.nodes[0]?.slug === "local") &&
            <Link href={"/sg/blogs/local/"+ post.slug} prefetch={false} className={`${variant === "dark" ? "text-gray-300" : "text-orange-600"}`}>
                <h3 className='md:h-20 font-bold text-center text-sm md:text-base line-clamp-3 md:line-clamp-none'>{post.title}</h3>
            </Link>
        }
        {(post.categories?.nodes[0]?.slug === "general") &&
            <Link href={"/blogs/"+ post.slug} prefetch={false} className={`${variant === "dark" ? "text-gray-300" : "text-orange-600"}`}>
                <h3 className='md:h-20 font-bold text-center text-sm md:text-base line-clamp-3 md:line-clamp-none'>{post.title}</h3>
            </Link>
        }

        {/* Mobile fold budget: 16:9 on mobile instead of 4:3, and `sizes` corrected to
            50vw now that BlogsList renders a 2-up grid on phones. */}
        <div className='relative min-w-fit aspect-video md:aspect-4/3 mt-2 md:mt-3'>
            <Image className='rounded-xl'
                    src={post?.featuredImage?.node?.sourceUrl ?? s3Static + "logo.png"}
                    fill
                    style={{objectFit: 'cover'}}
                    placeholder='blur'
                    blurDataURL={s3Static + "placeholder.png"}
                    alt={post?.featuredImage?.node?.altText ?? "StringsSG logo"}
                    sizes="(max-width: 768px) 50vw, 33vw"
            />          
        </div>
        {/* Excerpt hidden on mobile - the title above is the link anchor text. */}
        <div className='hidden md:block text-sm text-gray-500 leading-7 overflow-hidden' dangerouslySetInnerHTML={{ __html: post.excerpt }} />
        <div className='pt-2 pb-1 md:py-10 text-center'>
            {(post.categories?.nodes[0]?.slug === "hvac-services") &&
                <Link href={"/sg/aircon-servicing-singapore/"+ post.slug} prefetch={false} className={`inline-block text-xs md:text-base px-2.5 py-1.5 md:px-4 md:py-3 border ${variant === "dark" ? "border-gray-700 text-gray-300" : "border-amber-600 text-orange-600 "} rounded-xl`}>
                    Continue Reading
                </Link>
            }
            {(post.categories?.nodes[0]?.slug === "health-fitness") &&
                <Link href={"/sg/blogs/health-fitness/"+ post.slug} prefetch={false} className={`inline-block text-xs md:text-base px-2.5 py-1.5 md:px-4 md:py-3 border ${variant === "dark" ? "border-gray-700 text-gray-300" : "border-amber-600 text-orange-600 "} rounded-xl`}>
                    Continue Reading
                </Link>
            }
            {(post.categories?.nodes[0]?.slug === "house-keeping") &&
                <Link href={"/sg/part-time-cleaner-singapore/"+ post.slug} prefetch={false} className={`inline-block text-xs md:text-base px-2.5 py-1.5 md:px-4 md:py-3 border ${variant === "dark" ? "border-gray-700 text-gray-300" : "border-amber-600 text-orange-600 "} rounded-xl`}>
                    Continue Reading
                </Link>
            }
            {(post.categories?.nodes[0]?.slug === "repair-renovation") &&
                <Link href={"/sg/handyman-singapore-services/"+ post.slug} prefetch={false} className={`inline-block text-xs md:text-base px-2.5 py-1.5 md:px-4 md:py-3 border ${variant === "dark" ? "border-gray-700 text-gray-300" : "border-amber-600 text-orange-600 "} rounded-xl`}>
                    Continue Reading
                </Link>
            }
            {(post.categories?.nodes[0]?.slug === "finance-insurance-investment") &&
                <Link href={"/sg/financial-adviser-singapore/"+ post.slug} prefetch={false} className={`inline-block text-xs md:text-base px-2.5 py-1.5 md:px-4 md:py-3 border ${variant === "dark" ? "border-gray-700 text-gray-300" : "border-amber-600 text-orange-600 "} rounded-xl`}>
                    Continue Reading
                </Link>
            }
            {(post.categories?.nodes[0]?.slug === "housing") &&
                <Link href={"/sg/property-agent/"+ post.slug} prefetch={false} className={`inline-block text-xs md:text-base px-2.5 py-1.5 md:px-4 md:py-3 border ${variant === "dark" ? "border-gray-700 text-gray-300" : "border-amber-600 text-orange-600 "} rounded-xl`}>
                    Continue Reading
                </Link>
            }
            {(post.categories?.nodes[0]?.slug === "local") &&
                <Link href={"/sg/blogs/local/"+ post.slug} prefetch={false} className={`inline-block text-xs md:text-base px-2.5 py-1.5 md:px-4 md:py-3 border ${variant === "dark" ? "border-gray-700 text-gray-300" : "border-amber-600 text-orange-600 "} rounded-xl`}>
                    Continue Reading
                </Link>
            }
            {(post.categories?.nodes[0]?.slug === "general") &&
                <Link href={"/blogs/"+ post.slug} prefetch={false} className={`inline-block text-xs md:text-base px-2.5 py-1.5 md:px-4 md:py-3 border ${variant === "dark" ? "border-gray-700 text-gray-300" : "border-amber-600 text-orange-600 "} rounded-xl`}>
                    Continue Reading
                </Link>
            }
        </div>
    </>
  )
}
